import { sendGTMEvent } from '@next/third-parties/google';

/**
 * Sends a Google Tag Manager event for a Gift Cards purchase.
 * @param {number} value - The total dollar value of the giftard purchased.
 * @param {boolean} isGift - Indicates if the purchase is a gift.
 * @returns {void}
 */
export const gtmGiftCardPurchaseEvent = (
    value: number,
    isGift: boolean,
): void => {
    sendGTMEvent({ ecommerce: null });
    sendGTMEvent({
        event: 'purchase',
        ecommerce: {
            value: value,
            currency: 'AUD',
            items: [
                {
                    item_id: "Gift_Card",
                    item_name: "Gift Card",
                    price: value,
                    isGift: isGift,
                },
            ],
        },
    });
};